import DepotTable from "./DepotTable";

export default function Depot() {
  return <DepotTable />;
}
